export const parseNumber = (number?: string | number) => {
  if (number === undefined) return 0;
  if (typeof number === 'string') return Number(number.replace(/,/g, ''));

  return number;
};
